import jwtAuthKioskAxios from "../auth/jwtAuthKiosk";
import { setBackendDomain } from "./management";

export const getReports = async (
  reportType,
  dateFrom,
  dateTo,
  month,
  year,
  location,
  paymentMethods
) => {
  setBackendDomain(jwtAuthKioskAxios);
  // Convert paymentMethods array to comma-separated string (empty = all)
  const paymentMethod =
    Array.isArray(paymentMethods) && paymentMethods.length > 0
      ? paymentMethods.join(",")
      : undefined;
  let data = {};
  try {
    switch (reportType) {
      case "closure":
        data = await jwtAuthKioskAxios.get(`/api/v1/reports/closure`, {
          params: { dateFrom, dateTo, month, year, location, paymentMethod },
        });
        return data?.data?.data;
      case "salesStatistics":
        data = await jwtAuthKioskAxios.get(`/api/v1/reports/sales-statistics`, {
          params: { dateFrom, dateTo, month, year, location, paymentMethod },
        });
        return data?.data?.data;
      case "clients":
        data = await jwtAuthKioskAxios.get(`/api/v1/reports/clients-orders`, {
          params: { dateFrom, dateTo, month, year, location },
        });
        return data?.data?.data;
      case "externalOrders":
        data = await jwtAuthKioskAxios.get(`/api/v1/reports/external-orders`, {
          params: { dateFrom, dateTo, month, year },
        });
        return data?.data?.data;
      case "productSales":
        data = await jwtAuthKioskAxios.get(`/api/v1/reports/product-sales`, {
          params: { dateFrom, dateTo, month, year, location },
        });
        return data?.data?.data;
      default:
        return null;
    }
  } catch (error) {}
};

export const getDSOKClientOrders = async (
  clientId,
  dateFrom,
  dateTo,
  month,
  year,
  location,
  paymentMethod
) => {
  setBackendDomain(jwtAuthKioskAxios);
  let data = {};
  data = await jwtAuthKioskAxios.get(
    `/api/v1/orders/customer/client/${clientId}`,
    {
      params: { dateFrom, dateTo, month, year, location, paymentMethod },
    }
  );
  return data?.data;
};
